var React = require("react");

var spinnerCharacters = "-\\|/";

var Spinner = React.createClass({
    propTypes: {
        style: React.PropTypes.object,
        Message: React.PropTypes.string,
        WithTimer: React.PropTypes.bool,
        IntervalMs: React.PropTypes.number,
        Large: React.PropTypes.bool
    },
    getDefaultProps(){
        return {
            style: {}
        };
    },
    getInitialState() {
        return {
            SpinnerIndex: 0,
            SpinnerCharacter: "-",
            Timer: null,
            IntervalMs: parseInt(this.props.IntervalMs) || 250,
            ElapsedMs: 0
        };
    },
    componentDidMount() {
        var timer = setInterval(this.Tick, this.state.IntervalMs);

        this.setState({
            ElapsedMs: 0,
            Timer: timer
        });
    },
    componentWillUnmount() {
        clearInterval(this.state.Timer);
    },
    render() {
        var style = Object.assign({
            padding: 10
        }, this.props.style);

        var spinnerStyle = {
            fontFamily: "'Lucida Console', Monaco, monospace",
            fontSize: "smaller",
            display: "inline-block",
            position: "relative",
            top: -2,
            left: 5
        };

        var timerDisplay;

        if (this.props.WithTimer) {
            timerDisplay = this.GetTimerDisplay();
        }

        var messageDisplay;

        if (this.props.Large) {
            messageDisplay = (<div>
                <h4 style={{ marginTop: 0 }}>
                    {this.props.Message}
                    <span style={spinnerStyle}>{this.state.SpinnerCharacter}</span>
                </h4>
            </div>);
        }
        else {
            messageDisplay = (<div>
                <p>
                    {this.props.Message}
                    <span style={spinnerStyle}>{this.state.SpinnerCharacter}</span>
                </p>
            </div>);
        }

        return (<div style={style}>
            {messageDisplay}
            {timerDisplay}
        </div>);
    },
    Tick() {
        if (this.isMounted()) {
            var index =
                this.state.SpinnerIndex === spinnerCharacters.length - 1
                ? 0
                : this.state.SpinnerIndex + 1;

            this.setState({
                SpinnerIndex: index,
                SpinnerCharacter: spinnerCharacters[index],
                ElapsedMs: this.state.ElapsedMs + this.state.IntervalMs
            });
        }
    },
    GetTimerDisplay() {
        var rem = this.state.ElapsedMs;
        var ms = rem % 1000;
        rem = (rem - ms) / 1000;
        var secs = rem % 60;
        rem = (rem - secs) / 60;
        var mins = rem % 60;

        var elapsed = ("0" + mins).slice(-2, 3) + ':' + ("0" + secs).slice(-2, 3);

        var elapsedStyle = {
            fontFamily: "'Lucida Console', Monaco, monospace",
            fontSize: "smaller",
            marginLeft: 5
        };

        return (<p style={elapsedStyle }>Run time: {elapsed}</p>);
    }
});

module.exports = Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner.jsx